import {isTestAccount} from '../../shared/services/is-test-account'

function removeTestAccounts(data) {
  return data.filter(item => {
    const {candidateDetails} = item
    const {email} = candidateDetails
    return !isTestAccount(email)
  })
}

angular.module('app.api').factory('RecommendationListingApi', [
  'api',
  function RecommendationListingApi(api) {
    const recommendationApi = {
      getPositionRecommendations: async id => {
        const result = await api.get(`recommendations/position/${id}`)

        const withoutTestAccounts = _.extend(_.clone(result), {
          data: removeTestAccounts(result.data),
        })
        console.debug(
          'getPositionRecommendations withoutTestAccounts',
          withoutTestAccounts
        )
        return withoutTestAccounts
      },
    }
    return recommendationApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/recommendation-listing/recommendation-listing.api.js